module.exports = __webpack_public_path__ + "static/knobcreek-41181f2f607e8b98e2e9ee194a2bc0cd.jpeg";